import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class MessageButton extends PureComponent {
    render() {
        const { onMessageClick, 'data-testid': dataTestId } = this.props;
        return (
            <div
                className="click-area click-area-24"
                onClick={(ev) => {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onMessageClick();
                }}
                data-testid={dataTestId || undefined}
            >
                <i className={`utr utr-message fs18 text-teal`} />
            </div>
        );
    }
}

MessageButton.propTypes = {
    'data-testid': PropTypes.string,
};

MessageButton.defaultProps = {
    'data-testid': null,
};

export default MessageButton;
